export default function XDate(...args) {
    this.d = new Date();
    if (args.length) {
        this.from(args[0]);
    }
}

XDate.prototype.locale = 'de';

XDate.prototype.setUnixtimestamp = function setUnixtimestamp(time) {
    this.d.setTime(time * 1000);
    return this;
};

XDate.prototype.setLocale = function setLocale(locale) {
    this.locale = locale;
    return this;
};

XDate.prototype.getUnixtimestamp = function getUnixtimestamp() {
    return Math.floor(this.d.getTime() / 1000);
};

XDate.prototype.descripe = function descripe() {
    return {
        day: this.date('d'),
        month: this.date('m'),
        year: parseInt(this.date('y'), 10),
        fullYear: parseInt(this.date('Y'), 10),
        '2diggets': {
            hour: this.date('H'),
            minutes: this.date('i'),
            seconds: this.date('s'),
        },
        hour: this.d.getHours(),
        minutes: this.d.getMinutes(),
        seconds: this.d.getSeconds(),
        dayname: this.date('l'),
        dayname_short: this.date('D'),
        monthname: this.date('F'),
        monthname_short: this.date('M'),
        dayofweek: this.date('N'),
        localtimezone: this.date('e'),
        differenceToGMT: this.date('O'),
        'am/pm': `${this.date('a')} / ${this.date('A')}`,
    };
};

XDate.prototype.toInt = function toInt(v) {
    return parseInt(v, 10);
};

XDate.prototype.datetest = function datetest() {
    /* eslint-disable no-console */
    console.log(this.date('d.m.y H:i:s \\U\\h\\r Y \\D:D \\l:l \\F:F \\M:M \\N:N \\e:e \\O:O \\a:a \\A:A \\W:W'));
    /* eslint-enable no-console */
};

/**
 * Beispiele
 * new XDate().date('d.m.y H:i:s \\U\\h\\r Y \\D:D \\l:l \\F:F
 * \\M:M \\N:N \\e:e \\O:O \\a:a \\A:A \\W:W');
 * new XDate().date('d',1);
 */
XDate.prototype.date = function date(...args) {
    let r = '';
    let l = '';
    let a = '';
    let t = '';
    let dayNum = '';
    let yearStart = '';
    let d = '';
    let d1 = '';
    const value = args[0];

    for (let i = 0; i < value.length; i += 1) {
        const c = value.substring(i, i + 1);
        // let n;

        switch (c) {
        case '\\':
            r += value[i + 1];
            i += 1;
            // continue;
            break;
        case 'e':
            l = `${this.locale}-`;
            l += this.locale + ''.toUpperCase();
            r += this.d.toLocaleDateString(l, {
                day: '2-digit', timeZoneName: 'long',
            }).slice(4);
            break;
        case 'a':
        case 'A':
            a = (this.d.getHours() < 12) ? 'am' : 'pm';
            r += (c === 'A') ? a.toUpperCase() : a;
            break;
        case 'O':
            r += this.d.getTimezoneOffset();
            break;
        case 'd':
            r += this.d.getDate().toString().padStart(2, '0');
            break;
        case 'D':
            r += new Intl.DateTimeFormat(this.locale, { weekday: 'short' }).format(this.d);
            break;
        case 'l':
            r += new Intl.DateTimeFormat(this.locale, { weekday: 'long' }).format(this.d);
            break;
        case 'F':
            r += new Intl.DateTimeFormat(this.locale, { month: 'long' }).format(this.d);
            break;
        case 'm':
            r += (this.d.getMonth() + 1).toString().padStart(2, '0');
            break;
        case 'M':
            r += new Intl.DateTimeFormat(this.locale, { month: 'short' }).format(this.d);
            break;
        case 'y':
            r += this.d.getFullYear().toString().substring(2, 4);
            break;
        case 'Y':
            r += this.d.getFullYear().toString();
            break;
        case 'h':
        case 'H':
            r += this.d.getHours().toString().padStart(2, '0');
            break;
        case 'i':
            r += this.d.getMinutes().toString().padStart(2, '0');
            break;
        case 's':
            r += this.d.getSeconds().toString().padStart(2, '0');
            break;
        case 'w':
            r += this.d.getDay();
            break;
        case 'W':
            t = new Date(Date.UTC(this.d.getFullYear(), this.d.getMonth(), this.d.getDate()));
            dayNum = t.getUTCDay() || 7;
            t.setUTCDate(t.getUTCDate() + 4 - dayNum);
            yearStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
            r += Math.ceil((((t - yearStart) / 86400000) + 1) / 7);
            break;
        case 'N': // ISO 8601 Montag=1,7=Sonntag=7
            d = this.d.getDay();
            if (d === 0) {
                r += 7;
                break;
            }
            r += d;
            break;
        case 't':
            d1 = new Date();
            d1.setTime(this.d.getTime());
            d1.setDate(1);
            d1.setMonth(d1.getMonth() + 1);
            d1.to('-1 day');
            r += d1.getDate();
            break;
        case 'G':
            r += this.d.getDate();
            break;
        default:
            r += c;
        }
    }
    return (args.length > 1) ? parseInt(r, 10) : r;
};

XDate.prototype.dateInt = function dateInt(...args) {
    return parseInt(this.date(args[0]), 10);
};

XDate.prototype.locales = {
    en: {
        shiftDays: {
            Sunday: 0,
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6,
        },
    },
    de: {
        shiftDays: {
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6,
            Sunday: 7,
        },
    },
};

XDate.prototype.toParsedDate = function toParsedDate(value) {
    let d = '';
    switch (value) {
    case 'today':
        d = new Date();
        this.d.setDate(d.getDate());
        this.d.setMonth(d.getMonth());
        this.d.setFullYear(d.getFullYear());
        break;
    default:
    }
    return this;
};

XDate.prototype.toMidnight = function toMidnight() {
    this.d.setHours(0);
    this.d.setMinutes(0);
    this.d.setSeconds(0);
};

XDate.prototype.intervall = function intervall(...args) {
    // let f;
    const r = [];
    let s;
    // const o;
    let value = args[0];
    let a = this.d.getTime();
    let l = this.convertDate(args[1], 'time') - a;
    const d = new Date(this.d.getTime());
    const f = (args.length > 2) ? args[2] : '';

    if (l < 0) {
        l *= -1;
    }
    l += a;

    value = value.replace(/^([+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`); // replace(/^([\+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`)
    // const p = value.split(' ');
    const [x, y, z] = value.split(' ');

    switch (x) {
    case '+':
    case '-':
        s = y;
        // const o = p[0];
        switch (z) {
        case 'minute':
            s *= 60;
            break;
        case 'hour':
            s *= 60 * 60;
            break;
        case 'day':
            s *= 86400;
            break;
        default:
        }
        break;
    default:
    }
    s *= 1000;
    while (a < l) {
        switch (f) {
        case 'format':
            r.push(d.date(args[3]));
            break;
        case 'unixtime':
            r.push(Math.floor(a / 1000));
            break;
        default:
            r.push(a);
        }
        a += s;
        d.setTime(a);
    }
};

XDate.prototype.getLocale = function getLocale() {
    return this.locale;
};

XDate.prototype.compare = function compare(c, val) {
    const t = this.getUnixtimestamp();
    // val = (typeof val === 'object' && val.hasOwnProperty('getUnixtimestamp'))
    val = (typeof val === 'object' && Object.prototype.hasOwnProperty.call(val, 'getUnixtimestamp'))
        ? val.getUnixtimestamp() : new XDate().from(val).getUnixtimestamp();
    switch (c) {
    case '<':
        return t < val;
    case '>':
        return t > val;
    case '<=':
        return t <= val;
    case '>=':
        return t >= val;
    case '==':
        return t === val;
    default:
    }
    return false;
};

XDate.prototype.from = function from(v) {
    this.d = (this.convertDate(v)).d;

    return this;
};

XDate.prototype.format = function format(value) {
    const p = value.split(' ');
    let y = '';
    let a = '';

    switch (p[0]) {
    case 'ymd':
    case 'Ymd':
        y = p[0].substring(0, 1);
        switch (this.locale) {
        case 'en':
            return this.date(`${y}-m-d`);
        default:
            return this.date(`d.m.${y}`);
        }
    case 'Hi':
        switch (this.locale) {
        case 'en':
            a = p[1] ? p[1] : 'a';
            return this.date(`h:i ${a}`);
        default:
            return this.date('H:i');
        }
    default:
    }
    return false;
};

XDate.prototype.to = function to(...args) {
    let t = 0;
    let m;
    let value = args[0];
    value = value.replace(/^([+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`); // replace(/^([\+-])(.+)/, (m, p1, p2) => `${p1} ${p2}`)
    const p = value.split(' ');
    let day = '';
    let pm = '';
    let cnt = 0;
    let d = '';

    switch (p[0]) {
    case '+':
    case '-':
        switch (p[2]) {
        case 'day':
        case 'week':
            m = (p[2] === 'week') ? 7 : 1;
            t = 86400 * 1000;
            if (p[0] === '+') {
                this.d.setTime(this.d.getTime() + (p[1] * t * m));
                return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
            }
            this.d.setTime(this.d.getTime() - (p[1] * t));
            return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
        case 'hour':
            m = this.d.getHours();
            if (p[0] === '+') {
                for (let i = 0; i < p[1]; i += 1) {
                    m += 1;
                    if (m === 24) {
                        m = 0;
                        this.to('+1 day');
                    }
                    this.d.setHours(m);
                }
            } else {
                for (let i = p[1]; i > 0; i -= 1) {
                    m -= 1;
                    if (m < 0) {
                        m = 23;
                        this.to('-1 day');
                    }
                    this.d.setHours(m);
                }
            }
            break;
        case 'minute':
            m = this.d.getMinutes();
            if (p[0] === '+') {
                for (let i = 0; i < p[1]; i += 1) {
                    m += 1;
                    if (m === 60) {
                        m = 0;
                        this.to('+1 hour');
                    }
                    this.d.setMinutes(m);
                }
            } else {
                for (let i = p[1]; i > 0; i -= 1) {
                    m -= 1;
                    if (m < 0) {
                        m = 59;
                        this.to('-1 hour');
                    }
                    this.d.setMinutes(m);
                }
            }
            break;
        case 'second':
            m = this.d.getSeconds();
            if (p[0] === '+') {
                for (let i = 0; i < p[1]; i += 1) {
                    m += 1;
                    if (m === 60) {
                        m = 0;
                        this.to('+1 minute');
                    }
                    this.d.setSeconds(m);
                }
            } else {
                for (let i = p[1]; i > 0; i -= 1) {
                    m -= 1;
                    if (m < 0) {
                        m = 59;
                        this.to('-1 minute');
                    }
                    this.d.setSeconds(m);
                }
            }
            break;
        case 'month':
            m = this.d.getMonth();
            if (p[0] === '+') {
                for (let i = 0; i < p[1]; i += 1) {
                    m += 1;
                    if (m === 12) {
                        m = 0;
                        this.to('+1 year');
                    }
                    this.d.setMonth(m);
                }
            } else {
                for (let i = p[1]; i > 0; i -= 1) {
                    m -= 1;
                    if (m < 0) {
                        m = 11;
                        this.to('-1 year');
                    }
                    this.d.setMonth(m);
                }
            }
            break;
        case 'year':
            if (p[0] === '+') {
                this.d.setFullYear(this.d.getFullYear() + parseInt(p[1], 10), 10);
            } else {
                this.d.setFullYear(this.d.getFullYear() - parseInt(p[1], 10), 10);
            }
            break;
        default:
        }
        return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
    case 'next':
    case 'last':
        if (p.length >= 4 && p[0] + p[1] + p[2] + p[3] === 'lastdayofmonth') {
            this.d.setDate(1);
            this.to('+1 month').to('-1 day');
            return (p.length > 4) ? this.to(p.splice(4).join(' ')) : this;
        }
        switch (p[1]) {
        default:
            day = this.locales.de.shiftDays[p[1]] ? this.locales.de.shiftDays[p[1]] : null;
            if (!day) {
                /* eslint-disable no-console */
                console.error(`${p[1]} nicht definiert`);
                /* eslint-enable no-console */
                return this;
            }
            pm = (p[0] === 'next') ? '+' : '-';
            cnt = 0;
            while (this.dateInt('N') !== this.locales.de.shiftDays[p[1]]) {
                this.to(`${pm}1 day`);
                cnt += 1;
                if (cnt > 10) {
                    break;
                }
            }
            return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
        }
    case 'first':
        if (p.length >= 4 && p[1] + p[2] + p[3] === 'dayofmonth') {
            this.d.setDate(1);
            return (p.length > 4) ? this.to(p.splice(4).join(' ')) : this;
        }
        break;
    case 'second':
        this.d.setSeconds(p[1]);
        return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
    case 'minute':
        this.d.setMinutes(p[1]);
        return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
    case 'hour':
        this.d.setHours(p[1]);
        return (p.length > 2) ? this.to(p.splice(2).join(' ')) : this;
    case 'midnight':
        this.toMidnight();
        return (p.length > 1) ? this.to(p.splice(1).join(' ')) : this;
    case 'today':
        d = new Date();
        this.d.setDate(d.getDate());
        this.d.setMonth(d.getMonth());
        this.d.setFullYear(d.getFullYear());
        return (p.length > 1) ? this.to(p.splice(1).join(' ')) : this;
    default:
    }

    if (p[1] === 'this' && p[2] === 'week') {
        const day = this.locales.de.shiftDays[p[0]];
        if (!day) {
            /* eslint-disable no-console */
            console.error(`${p[0]} nicht definiert`);
            /* eslint-enable no-console */
            return this;
        }
        if (this.dateInt('N') !== day) {
            const pm = (this.date('N', 1) > day) ? '-' : '+';
            while (this.date('N', 1) !== day) {
                this.to(`${pm}1 day`);
            }
        }
        return (p.length > 3) ? this.to(p.splice(3).join(' ')) : this;
    }
    this.d = this.from(this.convertDate(Date.parse(value))).d;
    return this;
};

XDate.prototype.copy = function copy() {
    const copy = new XDate(this.d.getTime());
    copy.setLocale(this.locale);
    return copy;
};

XDate.prototype.lastMonday = function lastMonday() {
    const prevMonday = new Date();
    return prevMonday.setDate((prevMonday.getDate() - (prevMonday.getDay() + 6)) % 7);
};

XDate.prototype.convertDate = function convertDate(v, ...args) {
    let x;
    let to = (args.length > 1) ? args[1] : 'XDate';
    const [b] = (args.length > 1) ? args[2] : '';

    switch (typeof v) {
    case 'object':
        if (v.getUnixtimestamp) {
            x = v;
        } else if (v.setTime) {
            x = new XDate().from(v.getTime());
        }
        break;
    case 'number':
        x = new XDate();
        if (v.toString().length < 11) {
            x.d.setTime(parseInt(v, 10) * 1000);
            // x.d.setTime(parseInt(v) * 1000+(x.d.getTimezoneOffset()*60*1000));
        } else {
            x.d.setTime(parseInt(v, 10));
        }
        break;
    case 'string':
        x = (args.length > 2) ? args[1] : new XDate().to(v);
        switch (args.length) {
        case 1:
        case 2:
            to = 'XDate';
            break;
        case 3:
            to = b; // arguments[2];
            break;
        default:
        }
        break;
    default:
    }
    let t;
    switch (to) {
    case 'time':
        t = x.d.getTime();
        break;
    case 'unixtime':
        t = x.getUnixtimestamp();
        break;
    case 'format':
        t = x.date(args[2]);
        break;
    default:
        t = x;
    }
    return t;
};
